export default __webpack_public_path__ + "755968bc006472e1d21edc59856a42dc.png";